export default {
	api: {
		endpoint: 'https://api.speakly.flaire.nl'
	},
	websocket: {
		endpoint: 'wss://ws.speakly.flaire.nl'
	}
};

// LIVE
// api: {
// 	endpoint: 'https://api.speakly.flaire.nl'
// },
// websocket: {
// 	endpoint: 'wss://ws.speakly.flaire.nl'
// }

// DEV
// api: {
// 	endpoint: 'http://localhost:8080'
// },
// websocket: {
// 	endpoint: 'ws://localhost:8081'
// }